import DefaultTipComponent from './index.vue'

const DefaultTip = {
  install: function(Vue) {
    Vue.component('defaultTip', DefaultTipComponent)
  }
}

export default DefaultTip



// WEBPACK FOOTER //
// ./src/components/defaultTip/index.js